// extracted by mini-css-extract-plugin
module.exports = {"mdvPlansWrapper":"mdvPlansWrapper_mdvPlansWrapper__13aRD","networkSelector":"mdvPlansWrapper_networkSelector__Czc1a"};